var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4583 0.5H1.875C0.839042 0.5 0 1.34425 0 2.375V13.625C0 14.6619 0.845208 15.5 1.875 15.5H19.4583C20.4856 15.5 21.3333 14.6654 21.3333 13.625V2.375C21.3333 1.34608 20.4976 0.5 19.4583 0.5ZM19.1958 1.75C18.8127 2.13104 12.2201 8.68888 11.9925 8.91529C11.6383 9.26946 11.1675 9.46446 10.6667 9.46446C10.1658 9.46446 9.695 9.26942 9.33967 8.91413C9.18658 8.76183 2.66679 2.27642 2.13758 1.75H19.1958ZM1.25 13.3706V2.63021L6.65158 8.00333L1.25 13.3706ZM2.13838 14.25L7.53783 8.88488L8.45696 9.79917C9.04721 10.3894 9.83196 10.7145 10.6667 10.7145C11.5014 10.7145 12.2861 10.3894 12.8752 9.80033L13.7955 8.88488L19.195 14.25H2.13838ZM20.0833 13.3706L14.6818 8.00333L20.0833 2.63021V13.3706Z",
    fill: "#5D5A6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailFooter);
export default __webpack_public_path__ + "static/media/email-footer.a496d07d99343f2fd6931ddab4745e31.svg";
export { ForwardRef as ReactComponent };